import { ApolloError } from "@apollo/client";

export const getErrorMessage = (error: unknown): string | undefined => {
  if (!(error instanceof ApolloError)) return undefined;
  const [graphQLError] = error.graphQLErrors;
  if (
    !graphQLError ||
    graphQLError.extensions?.code === "INTERNAL_SERVER_ERROR"
  )
    return undefined;
  return graphQLError.message;
};

export const cleanGraphQLData = (obj: object): object => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(cleanGraphQLData);
  }

  if (typeof obj === "object") {
    const cleaned: { [key: string]: unknown } = {};
    for (const [key, value] of Object.entries(obj)) {
      if (Array.isArray(value)) {
        cleaned[key] = value.map(cleanGraphQLData);
      }

      if (key !== "__typename") {
        cleaned[key] = cleanGraphQLData(value);
      }
    }
    return cleaned;
  }

  return obj;
};
